import { RootState } from "@store/store";
import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";
import { ROUTES } from "./RouteConstant";
import { useAuthVerification } from "@hooks/useAuthVerification";

interface ProtectedPortalRouteProps {
  children?: ReactNode;
}

const ProtectedPortalRoute: React.FC<ProtectedPortalRouteProps> = ({
  children,
}) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.authenticated,
  );

  // const isPortalProtected = useSelector(
  //   (state: RootState) => state.tokenData.tokenData.portalProtected
  // );

  const { isLoading } = useAuthVerification(false);

  if (isLoading) {
    return (
      <div className="overlay-loader" role="status" aria-label="Loading">
        <div className="spinner" aria-hidden="true"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />; // Redirect to login on unauthenticated access
  }

  // if (isPortalProtected) {
  //   return <Navigate to={ROUTES.DASHBOARD} replace />;
  // }
  return children ? <>{children}</> : <Outlet />; // Render children or Outlet for nested routes
};

export default ProtectedPortalRoute;
